import { useRef } from 'react';
import { clsx } from 'clsx';

import { Button, TDropdownMenu } from '@treezor/design-system';

import { AdvancedDropdown, TAdvancedDropdownItem } from '@/ui-kit/dropdown/AdvancedDropdown';
import { useToggle } from '@/hooks/useToggle';

export type TAdvancedDropdownMenu = Omit<TDropdownMenu, 'items'> & { items: TAdvancedDropdownItem[] };

export function AdvancedDropdownMenu({
  size = 's',
  className,
  testId,
  children,
  disabled,
  items,
  closeOnSelect = false,
  isLoading,
  variant = 'secondary',
  onClickItem,
}: TAdvancedDropdownMenu) {
  const buttonRef = useRef<HTMLButtonElement & HTMLAnchorElement>(null);

  const [isDropdownOpen, toggleDropdown] = useToggle(false);

  const onClick = () => {
    if (disabled) return;
    toggleDropdown();
  };

  return (
    <div className={clsx('relative', className)}>
      <Button
        ref={buttonRef}
        size={size}
        testId={testId}
        variant={variant}
        iconPosition="right"
        icon={isDropdownOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
        disabled={disabled}
        isActive={isDropdownOpen}
        onClick={onClick}
        isLoading={isLoading}
      >
        {children}
      </Button>

      {isDropdownOpen && !disabled && (
        <AdvancedDropdown
          items={items}
          closeOnSelect={closeOnSelect}
          onClose={toggleDropdown}
          parentRef={buttonRef}
          onClickItem={onClickItem}
          size={size}
        />
      )}
    </div>
  );
}
